/* eslint-disable object-curly-newline */
/* eslint-disable comma-dangle */
/* eslint-disable operator-linebreak */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable indent */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import { Container, ThemeProvider } from '@mui/material';
import { useHistory } from 'react-router-dom';
import FabButton from '../Buttons/FabButton';
import tableTheme from '../Theme';
import EditIcon from '@mui/icons-material/Edit';
import Global from '../../Global.module.css';
import { FileUploadOutlined } from '@mui/icons-material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { handleExportCsv, handleExportPdf } from './helpers';
import { EmptyDataMessage } from './components/EmptyDataMessage';
import { ImportIcon } from './components/ImportIcon';
import AddUnityIcon from './components/AddUnityIcon';
import AddIcon from '@mui/icons-material/Add';
import SnackbarDisplayErrors from './components/SnackbarDisplayErrors';
import { ReactComponent as DuplicateIcon } from '../../images/icons/duplicate-alt.svg';
import { CustomIcon } from 'components/CustomIcon';
import SalesService from 'services/SalesService';
import { useDependencyInjection } from 'hooks/useDependencyInjection';
import { useDispatch } from 'react-redux';
import {
  handleEmptyPermissions,
  handlePermissionsUserSelect,
} from 'redux/permissionUserSelect/actions';

/**
 *
 * Componente responsável por renderizar tabela do material-table
 * @param {*} title título da tabela
 * @default Obs: Você sempre deverá colocar o title pois ele também é responsável pelo nome do arquivo ao ser exportado.
 * @param {*} titleCustomized título da tabela se necessário customizar
 * @param {*} routeAdd rota destino ao clicar em um item da listagem
 * @param {*} data dados necessários para renderizar a tabela
 * @param {*} dataLoaded informa se os dados foram devidamente carregados
 * @param {*} columns colunas que serão exibidas na tabela
 * @param {*} columnsForExport colunas específicas para exportação
 * @param {*} copy habilita ou não a opção de copiar linha
 * @param {*} exportData dados que serão exportados
 * @param {*} onPost método responsável por fazer o post das informações de uma planilha importada
 * @param {*} errorsPost indica se houve algum erro durante o post das informações de uma planilha importada.
 * @param {*} hasError informa se ocorreu algum erro durante o processo de importação da planilha
 * @param {*} importButtonVisible habilita ou não o botão de importação
 * @param {*} isMeasurements indica se a página onde a tabela está renderizando é a de Medidas
 * @returns retorna a tabela renderizada
 */

export default function Table({
  title,
  titleCustomized,
  routeAdd,
  data,
  dataLoaded,
  columns,
  columnsForExport,
  fab,
  copy = true,
  isVisible = true,
  exportData,
  onPost,
  hasError,
  importButtonVisible = false,
  errorsPost,
  onCloseSnackbar,
  isMeasurements,
  routeClick,
  blockClick = false,
  searchText,
  ...rest
}) {
  const dispatch = useDispatch();

  const [pageSizeOptions, SetPageSizeOptions] = useState([10]);

  const history = useHistory();

  const { error } = useDependencyInjection();

  const icons = {
    Edit: () => <EditIcon color="action" />,
    Export: () => <FileDownloadOutlinedIcon style={{ color: '#A9A9A9' }} />,
  };

  const pushToHistory = (route, payload, id) => {
    history.push({
      pathname: route + id,
      state: {
        data: payload,
        id,
      },
    });
  };

  const handleClick = async (_data) => {
    if (blockClick) return;

    dispatch(handlePermissionsUserSelect(_data));
    const { id, multiplier } = _data;
    let route = routeAdd;

    if (isMeasurements && multiplier) {
      route = '/custom-unit/';
    } else if (routeClick) {
      route = routeClick;
    }

    if (rest.prevRoute) {
      const ERROR_NO_ID = 'Não foi possível abrir esta conta!';
      const ERROR_NO_SALE = 'Esta conta não está vinculada a uma venda!';

      if (!id) {
        error(ERROR_NO_ID);
        return;
      }
      const sale = await SalesService.saleByIdBill(id);

      if (!sale) {
        error(ERROR_NO_SALE);
        return;
      }

      pushToHistory(routeAdd, sale, sale.id);
      return;
    }

    pushToHistory(route, _data, id);
  };

  const handleAdd = () => {
    const { pond, productType, routeForConsignmentPurchase, prevRoute } = rest;

    const dataToAdd = {};

    if (pond) {
      dataToAdd.pond = { description: pond };
    }

    if (productType) {
      dataToAdd.productType = { description: productType };
    }

    if (prevRoute) {
      dataToAdd.prevRoute = { path: prevRoute };
    }

    history.push({
      pathname: routeForConsignmentPurchase ?? routeAdd,
      state: dataToAdd,
    });
  };

  const handleAddCustomMeasure = () => {
    history.push({
      pathname: '/custom-unit/',
    });
  };

  const handleCopy = (_data) => {
    // Os parametros da linha são passado via rota, e capturados via useLocations
    let route = routeAdd;
    if (isMeasurements && _data.multiplier) {
      route = '/custom-unit/';
    } else if (routeClick) {
      route = routeClick;
    }

    history.push({
      pathname: route,
      state: { customData: _data },
    });
  };

  const handleValuesPermissionsEmpty = () => {
    dispatch(handleEmptyPermissions());
  };
  // Mudando as opções por página de acordo com a quantidade de informação
  useEffect(() => {
    handleValuesPermissionsEmpty();
    if (data.length > 10 && data.length <= 15) {
      SetPageSizeOptions([10, 15]);
    } else if (data.length > 15 && data.length <= 20) {
      SetPageSizeOptions([10, 15, 20]);
    } else if (data.length > 20 && data.length <= 50) {
      SetPageSizeOptions([10, 15, 20, 50]);
    } else if (data.length > 50) {
      SetPageSizeOptions([10, 15, 20, 50, 100]);
    }
  }, [data]);

  return (
    <ThemeProvider theme={tableTheme}>
      <header className={Global.headerGlobal}>
        <br />
        <MaterialTable
          style={{ borderRadius: '20px', zIndex: 0, padding: '12px' }}
          title={titleCustomized || title}
          columns={columns}
          data={data}
          icons={icons}
          actions={[
            importButtonVisible && {
              icon: () => (
                <ImportIcon
                  columnsForExport={columnsForExport}
                  title={title}
                  onPost={onPost}
                  icon={<FileUploadOutlined sx={{ color: '#A9A9A9' }} />}
                />
              ),
              isFreeAction: true,
            },
            isVisible &&
              !fab &&
              !isMeasurements && {
                icon: 'add',
                tooltip: 'Adicionar',
                iconProps: {
                  style: {
                    backgroundColor: '#00C051',
                    borderRadius: '50%',
                    color: 'white',
                    fontSize: '35px',
                  },
                },
                isFreeAction: true,
                onClick: () => {
                  handleAdd();
                },
              },
            isMeasurements && {
              icon: () => (
                <AddUnityIcon
                  icon={<AddIcon sx={{ fontSize: 35 }} />}
                  onUnitOfMeasurement={handleAdd}
                  onCustomMeasure={handleAddCustomMeasure}
                />
              ),
              isFreeAction: true,
            },
            copy && {
              icon: () => <CustomIcon icon={DuplicateIcon} />,
              iconProps: { color: 'action' },
              tooltip: 'Duplicar',
              onClick: (event, rowData) => {
                handleCopy(rowData);
              },
            },
          ]}
          localization={{
            header: {
              actions: '',
            },
            body: {
              editTooltip: 'Edição rápida',
              emptyDataSourceMessage: (
                <div>
                  {dataLoaded && !hasError ? (
                    'Nenhum registro para exibir'
                  ) : (
                    <EmptyDataMessage
                      hasError={hasError}
                      onReload={() => document.location.reload(true)}
                    />
                  )}
                </div>
              ),
              filterRow: {
                filterTooltip: 'Filtro',
              },
            },
            toolbar: {
              editRow: 'Editar',
              editTooltip: 'Editar',
              searchTooltip: 'Pesquisar',
              searchPlaceholder: 'Pesquisar',
              exportTitle: 'Exportar',
              exportCSVName: 'Exportar como CSV',
              exportPDFName: 'Exportar como PDF',
            },
            pagination: {
              labelRowsSelect: 'linhas',
              labelDisplayedRows: '{count} de {from}-{to}',
              firstTooltip: 'Primeira página',
              previousTooltip: 'Página anterior',
              nextTooltip: 'Próxima página',
              lastTooltip: 'Última página',
            },
          }}
          options={{
            filtering: false,
            exportButton: true,
            search: true,
            pageSize: 10,
            pageSizeOptions,
            emptyRowsWhenPaging: false,
            minBodyHeight: 650,
            sorting: true,
            searchText: searchText ? searchText : '',
            exportCsv: (_columns, _renderData) => {
              handleExportCsv(
                _columns,
                _renderData,
                exportData,
                columnsForExport,
                title
              );
            },
            exportPdf: (_columns, _renderData) => {
              handleExportPdf(
                _columns,
                _renderData,
                exportData,
                columnsForExport,
                title
              );
            },
          }}
          onRowClick={(evt, rowData) => {
            handleClick(rowData);
          }}
        />
        <div>
          <SnackbarDisplayErrors
            errors={errorsPost}
            onCloseSnackbar={onCloseSnackbar}
          />
          {isVisible ? (
            <Container>{!fab ? <FabButton to={routeAdd} /> : fab}</Container>
          ) : (
            ''
          )}
        </div>
        <br />
      </header>
    </ThemeProvider>
  );
}
